<script>
  import { candidateStore } from "../stores";
  import { getCallsQuery } from "./Calls/callsQuery.svelte.js";
  import { callsQueryParams } from "./Calls/callsQueryParams.svelte";
  import CallsTable from "./Calls/CallsTable.svelte";
  import { getCallsQueryStore } from "./Calls/stores";

  const callsQueryStore = getCallsQueryStore();
  const callsQuery = getCallsQuery(callsQueryStore);

  $: callsQueryParams.candidateIds = $candidateStore?.candidateId
    ? [$candidateStore.candidateId]
    : [];
</script>

<CallsTable
  {callsQuery}
  {callsQueryParams}
  {callsQueryStore}
  style="padding: 0; margin-top: 16px;"
/>
